"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.knowledge.exceeded': 'Knowledge entry limit reached. Upgrade your plan to add more entries.',
    'limits.knowledge.limitReached': 'Knowledge limit: {limit} (upgrade to add more)',
};
